<!--
로딩 컴포넌트
-------------------
크기는 em 으로 작성되어있기때문에 부모요소의 크기를 자동으로 따라감
-->
<template>
    <div class="loader" :style="'border-color: '+bgColor+'; border-top-color: '+foreColor+';'"></div>
</template>

<script>
    export default {
        props: {
            bgColor: {
                type: String,
                default: '#f3f3f3',
            },
            foreColor: {
                type: String,
                default: '#3498db',
            },
        },
        data: function () {
            return {

            };
        },
        computed: {
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
    .loader {
        display: inline-block;

        border-style: solid;
        border-width: 0.25rem;
        //border-color: #f3f3f3; // 배경

        //border-top-style: solid;
        //border-top-width: 0.25rem;
        //border-top-color: #3498db; // 전면

        border-radius: 50%;
        width: 1em;
        height: 1em;
        animation: spin 2s linear infinite;

        vertical-align: middle;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>